import { Box, Link, Tooltip, Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { REACT_MANAGE_ACCESSLEVELS } from "../../actions/EndPoints";
import { ReactComponent as CreateIcon } from "../../assets/USA_Images/CreateIcon.svg";
import DataTableLatest from "../../components/DataTable/DataTableLatest";
import DeleteDialog from "../../components/DialogBoxComponent/DeleteDialog";
import Toast from "../../components/ToastContainer/CustomToast";
import { getPurposeType } from "../../slices/PurposeTypeGlobalUSA/PurposeTypeGlobalSlice";
import {
  deleteVisitorAccessLevels,
  getVisitorAccessLevels,
} from "../../slices/VisitorAccessLevels/VisitorAccessLevelSlice";
import { ThemeContext } from "../../theme/ThemeContext";
import ChecklistFilterForm from "../Checklist/ChecklistFilterForm";
import EditIcon from "../Person/EditIcon";
import AddAccessLevelDialog from "./AddAccessLevelDialog";
import DoorIcon from "./DoorIcon";
import RefreshIcon from "./RefreshIcon";

function VisitingAccessLevels() {
  const [rows, setRows] = useState([]);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const history = useHistory();
  const [del, setDel] = useState(false);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(1);
  const [clear, setClear] = useState(false);
  const [searchedRows, setSerchedRows] = useState([]);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [selectedObject, setSelectedObject] = useState({});
  const [pageSize, setPageSize] = useState(0);
  const { darkMode, setDiaLogBoxBlur } = useContext(ThemeContext);

  const [paging, setPaging] = useState({
    page: 1,
    rowsPerPage: 50,
  });
  const [filter, setFilter] = useState({
    name: "",
    parentId: "",
  });

  const defaultPaging = {
    page: 1,
    rowsPerPage: 10,
  };

  const defaultFilter = {
    name: "",
    parentId: "",
  };

  useEffect(() => {
    loadData(filter, paging);
  }, [filter, paging, clear]);

  useEffect(() => {
    if (del === true && parseInt(pageSize) !== 1) {
      loadData(filter, { page: page, rowsPerPage: rowsPerPage });
      setDel(false);
    } else {
      if (del === true) {
        setPaging({ page: page - 1, rowsPerPage: rowsPerPage });
        setDel(false);
      }
    }
  }, [del]);

  const handleChange = (newPage, size) => {
    setPage(newPage);
    setRowsPerPage(size);
    setPaging({
      page: newPage,
      rowsPerPage: size,
    });
  };

  const handleOpen = () => {
    setOpenEditDialog(true);
    setDiaLogBoxBlur(true);
  };

  const handleClose = () => {
    setOpenEditDialog(false);
    setDiaLogBoxBlur(false);
  };

  const resetFilter = () => {
    setClear(false);
    setPaging({ ...paging, page: 1 });
    setFilter(defaultFilter);
  };

  const loadData = (filter, paging) => {
    dispatch(getVisitorAccessLevels(Object.assign(filter, paging)))
      .unwrap()
      .then((data) => {
        if (data.code === "DMSI0000" && data.data) {
          setTotalRecords(data.data.totalCount);
          setRows(data.data.accessGroups);
          setPage(data.data.currentPage);
          setTotalPages(data.data.totalPages);
          setPageSize(data.data.pageSize);
        } else {
          setRows([]);
        }
      })
      .catch((er) => { });
  };

  const handleFilter = (data) => {
    setClear(true);
    setPaging({ ...paging, page: 1 });
    setFilter({
      name: data.name,
    });
  };

  const [pagingg, setPagingg] = useState({
    page: 1,
    rowsPerPage: 10,
  });
  const [filterr, setFilterr] = React.useState({
    name: "",
  });

  const handleDelete = (data) => {
    let delPayLoad = {
      id: data.id,
      name: data.name,
    };
    dispatch(getPurposeType(Object.assign(filterr, pagingg)))
      .unwrap()
      .then((data) => {
        if ((data.code = "CVAI0000" && data.data)) {
          const purposeTypes = data.data.purposeTypes;
          const isValuePresent = purposeTypes.some((obj) =>
            obj.accessLevelIds.includes(delPayLoad.id)
          );
          if (isValuePresent === false) {
            dispatch(deleteVisitorAccessLevels(delPayLoad))
              .unwrap()
              .then((data) => {
                if (data.code === "DMSI0000") {
                  Toast(t("COMMON132"), "success");
                  loadData(filter, paging);
                } else if (data.code === "DMSE00542") {
                  Toast(t("ACCESS_LEVEL_MAPPED_DOOR"), "error");
                } else Toast(data.message, "error");
              })
              .catch((er) => { });
          } else {
            Toast(t("ACCESS_LEVEL_ALREADY_MAPPED_PURPOSE_TYPE"), "error");
          }
        }
      })
      .catch((er) => { });
  };

  const columns = React.useMemo(
    () => [
      {
        headerName: "",
        sortable: false,
        width: 5,
        renderCell: (params) => {
          return <div></div>;
        },
      },
      {
        field: "name",
        headerName: t("VISACCLEVELS002"),
        flex: 1.5,
        width: 10,
        valueGetter: (params) => params.row.name,
        renderCell: (params) => (
          <Tooltip title={` ${params.row.name}`} placement="bottom-start">
            <span>{params.row.name}</span>
          </Tooltip>
        ),
      },
      {
        field: "timeSlot",
        headerName: t("ADD025"),
        flex: 1,
        width: 10,
        valueGetter: (params) => params.row.timeSlotName,
        renderCell: (params) => (
          <Tooltip
            title={` ${params.row.timeSlotName}`}
            placement="bottom-start"
          >
            <span>{params.row.timeSlotName}</span>
          </Tooltip>
        ),
      },
      {
        field: "Actions",
        headerName: t("ACTION"),
        type: "actions",
        flex: 1,
        width: 10,
        headerAlign: "center",
        getActions: (params) => [
          <Box onClick={() => {
            history.push({
              pathname: REACT_MANAGE_ACCESSLEVELS,
              state: { data: params.row },
            });
          }}>
            <DoorIcon />
          </Box>,
          <Box onClick={() => {
            setSelectedObject({
              id: params.row.id,
              name: params.row.name,
              schedulerId: params.row.schedulerId,
              edit: true,
            });
            handleOpen()
          }}>
            <EditIcon />
          </Box>,
          <Box >
            <DeleteDialog
              handleDelete={() => handleDelete(params.row)}
              deviceName={params.row.name}
              name={"Access Level"}
              text={"Are you sure you want to delete this "}
            />
          </Box>,
        ],
      },
    ],
    []
  );

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("darkMode");
    } else {
      document.body.classList.remove("darkMode");
    }
    return () => {
      document.body.classList.remove("darkMode");
    };
  }, [darkMode]);

  return (
    <>
      <Box>
        <Typography variant="h3" style={{ color: darkMode ? "#ffff" : "" }}>
          {t("Access Levels")}
        </Typography>
      </Box>
      <Box style={{
        display: "flex",
        flexDirection: "row-reverse",
        justifyContent: "flex-start",
        alignItems: "center",
        gap: "3px"
      }}>
        <Box item>
          {clear && (
            <Link
              href="#"
              underline="hover"
              className="line"
              style={{
                opacity: "0.8",
                color: "#E3393C",
                fontSize: "14px",
                underline: "hover",
                display: "inline",
              }}
              onClick={resetFilter}
            >
              {"Clear Filter"}
            </Link>
          )}
        </Box>
        <Tooltip title={t("Visiting Access Level")}>
          <Box item className={"addIcon"}
            onClick={handleOpen}>
            <CreateIcon />
          </Box>
        </Tooltip>
        <Tooltip title={t('COMMON002')}>
          <Box item className={darkMode ? 'refreshIcondark' : 'refreshIcon'}
            onClick={() => loadData(filter, paging)}>
            <RefreshIcon />
          </Box>
        </Tooltip>
        <Box item>
          <ChecklistFilterForm
            rowsPerPage={rowsPerPage}
            applyFilter={(data) => handleFilter(data)}
          />
        </Box>
      </Box>
      <div style={{ height: 300, width: "100%", paddingTop: "10px" }}>
        <DataTableLatest
          columns={columns}
          rows={searchedRows.length === 0 ? rows : searchedRows}
          page={page}
          getRowId={(row) => row.id}
          pageCount={totalPages}
          pageSize={rowsPerPage}
          count={totalRecords}
          handleChange={(newPage, size) => handleChange(newPage, size)}
        />
      </div>
      {openEditDialog ? (
        <AddAccessLevelDialog
          open={openEditDialog}
          handleDialogClose={handleClose}
          selectedObject={selectedObject}
          updateSelectedObject={() => {
            setSelectedObject({});
          }}
          loadData={() => {
            loadData(filter, paging);
          }}
        />
      ) : null}
    </>
  );
}

export default VisitingAccessLevels;
